const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.vale.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mkpezi3wre.execute-api.us-east-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-east-2',
    URL: 'https://bd8g8pzn40.execute-api.us-east-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.staging.vale.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.staging.vale.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.staging.vale.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.staging.vale.forwoodsafety.com',
    WEBSOCKET: 'wss://jiap0cb7vj.execute-api.us-east-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
